import { isNumber, map } from 'lodash/fp';

import { PaginationItem, PaginationLink } from '../../styles';
import { PaginationWrapper } from './styles';
import constants from '../../../../ahm-constants';
import PaginationChevronLink, { DIRECTION } from '../pagination-chevron-link';

const { URLS } = constants;

type PaginationProps = {
  currentPage: number;
  canGoBack: boolean;
  canGoForward: boolean;
  pagesToDisplay: (number | string)[];
};

const Pagination = ({ currentPage, canGoBack, canGoForward, pagesToDisplay }: PaginationProps) => (
  <PaginationWrapper>
    <PaginationChevronLink isDisabled={!canGoBack} pageNumber={currentPage - 1} direction={DIRECTION.LEFT} />

    {map((pageToDisplayItem) => {
      const isCurrentPage = currentPage === pageToDisplayItem;
      return (
        <PaginationItem
          aria-current={isCurrentPage ? 'page' : undefined}
          isCurrentPage={isCurrentPage}
          key={pageToDisplayItem}
        >
          {isNumber(pageToDisplayItem) ? (
            // TODO: AP-2219 - update the link to use the current hub as the URL domain
            // Explained hub URL still needs to be added to ahm-urls
            <PaginationLink to={`${URLS.SALES.ARTICLE_HUB}?page=${pageToDisplayItem}`}>
              {pageToDisplayItem}
            </PaginationLink>
          ) : (
            <span>{pageToDisplayItem}</span>
          )}
        </PaginationItem>
      );
    }, pagesToDisplay)}

    <PaginationChevronLink pageNumber={currentPage + 1} isDisabled={!canGoForward} direction={DIRECTION.RIGHT} />
  </PaginationWrapper>
);
export default Pagination;
